import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Row, Col, Form, Select, Button, Input } from 'antd';
import { ReactComponent as SearchIcon } from 'assets/img/icons/searchIcon.svg';
import { getCompanies } from 'store/entities/spiderWeb/thunks';
import { setSelectedCompany, setSelectedCountry, setIsSpiderwebOpen, resetSpiderWeb } from 'store/entities/spiderWeb';
import LoadingSpinner from 'components/reusable/LoadingSpinner';
import countries from 'mockData/countries.json';
import React, { useEffect } from 'react';

const { Option } = Select;

const SearchForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { isAuthenticated } = useSelector(state => state.user);
  const { getSearchResultsPending, selectedCountry } = useSelector(state => state.spiderWeb);

  const handleSubmit = values => {
    const searchRequest = {
      searchPhraseCompany: values.searchPhraseCompany || '',
      searchPhrasePerson: values.searchPhrasePerson || '',
      country: selectedCountry,
      relationTypes: [],
    };
    if (isAuthenticated) {
      dispatch(setSelectedCompany(null));
      dispatch(getCompanies(searchRequest));
    }
    dispatch(resetSpiderWeb());
  };

  useEffect(() => {
    dispatch(resetSpiderWeb());
  }, []);

  return (
    <Form
      form={form}
      hideRequiredMark
      layout="vertical"
      name="companySearchFilters"
      onFinish={handleSubmit}
      initialValues={{ country: 'LT' }}
    >
      <LoadingSpinner size="large" spinning={getSearchResultsPending}>
        <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Col span={21}>
            <Row gutter={[16, 16]}>
              <Col xs={24}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={8}>
                    <Form.Item name="searchPhraseCompany" style={{ marginBottom: 0 }}>
                      <Input placeholder={t('companySearch.companyName')} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item name="searchPhrasePerson" style={{ marginBottom: 0 }}>
                      <Input placeholder={t('companySearch.person.name')} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item name="country">
                      <Select
                        optionFilterProp="children"
                        showSearch
                        allowClear
                        onChange={value => {
                          dispatch(setSelectedCountry(value));
                        }}
                        placeholder={t('companySearch.choose.country')}
                      >
                        {countries.map(country => (
                          <Option key={country.value} value={country.value}>
                            {t(`search.country.${country.value}`)}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                htmlType="submit"
                icon={<SearchIcon style={{ width: 20, height: 20 }} />}
                onClick={() => dispatch(setIsSpiderwebOpen(false))}
              >
                {t('companySearch.search')}
              </Button>
            </Form.Item>{' '}
          </Col>
        </Row>
      </LoadingSpinner>
    </Form>
  );
};

export default SearchForm;
